module.exports = __webpack_public_path__ + "dc28f132a2e5621c44880cd8431604a6.jpg";